'use strict';

/**
 * @param {Object} form - the Url for the selected variation value
 * Handle Product Notification form submission
 */
function productNotification(form) {
    var url = form.attr('action');
    var button = form.find('button.submit-product-notification');

    $.spinner().start();
    button.attr('disabled', true);

    $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: form.serialize(),
        success: function (data) {
            $.spinner().stop();
            if (data.invalidProduct) {
                $('#notifymetModal').modal('hide');
                $('#invalidProductId').modal('show');
                button.removeAttr('disabled');
            } else {
                $('#notifymetModal').modal('hide');
                $('#successMessage').modal('show');
                button.removeAttr('disabled');
            }
        },
        error: function (err) {
            $('#successMessage .successMsg-container').text(err.msg);
            $.spinner().stop();
            $('#notifymetModal').modal('hide');
            $('#successMessage').modal('show');
            button.removeAttr('disabled');
        }
    });
}

module.exports = {
    productNotification: function () {
        $(document).on('submit', 'form.product-notification', function (e) {
            e.preventDefault();
            var $form = $(this);
            var validate = false;
            $('#form-notify-interests-error').hide();
            $form.find('input[type=checkbox]').each(function () {
                if ($(this).prop('checked')) {
                    validate = true;
                }
            });
            if (!validate) {
                $('#form-notify-interests-error').show();
                return false;
            }
            productNotification($form);
            return false;
        });

        $(document).on('change', 'form.product-notification input', function () {
            $('form.product-notification button').removeClass('disabled');
        });
    }
};
